

export default function PostsQualificationRenderer({ section }) {

    const rows = section?.fields?.rows || [];

    return (

        <div className="posts-qualification">

            <table className="table table-bordered">

                <thead>
                    <tr>
                        <th >Post Name</th>
                        <th style={{ width: "80px", textAlign: "center" }}>No of Vacancies</th>
                        <th>Qualification</th>
                        <th style={{ width: "180px" }}>Pay Scale</th>
                         <th style={{ width: "120px" }}>Age Limit</th>
                    </tr>
                </thead>

                <tbody>

                    {rows.map((row, index) => (

                        <tr key={index}>

                            <td>

                                <div className="post-name">
                                    {row.post_name?.value}
                                </div>

                                {/* {row.age_limit?.value && (
                                    <div className="post-age-limit">
                                        <strong>Age Limit:</strong> {row.age_limit.value}
                                    </div>
                                )} */}

                            </td>

                            <td data-label="No of Posts">
                                {row.total_posts?.value}
                            </td>

                            <td data-label="Qualification">

                                <div >
                                    {row.qualification?.value}
                                </div>

                                {row.experience?.value && (
                                    <div className="post-experience">
                                        <strong>Experience Required:</strong> {row.experience.value} years
                                    </div>
                                )}

                            </td>

                            <td data-label="Pay Scale">
                                {row.pay_scale?.value || "-"}
                            </td>

                            <td data-label="Age Limit">
                                {row.age_limit?.value} years
                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}